<div class="duplicate-day-container">
    <div class="duplicate-day-selector">
        <mwo-day-selector [justifyContentPosition]="'space-between'" [activeDay]="activeDay$ | async"
                          (daySelected)="onActiveDayChanged($event)"></mwo-day-selector>
    </div>

    <div class="edit-planning-row">
        <mwo-edit-planning (onDayChecked)="handleSelectedDays($event)" [activeDayIndex]="this.activeDayIndex"></mwo-edit-planning>
    </div>

    <div class="edit-action-row">
        <div>
            <mwo-main-button [disabled]="scheduleUpdateLoading$ | async" (onClick)="handleCancel()" text="{{'planning.cancel' | translate}}"></mwo-main-button>
        </div>
        <div>
            <mwo-main-button [disabled]="scheduleUpdateLoading$ | async" (onClick)="handleValidate()" text="{{'planning.validate' | translate}}"></mwo-main-button>
        </div>
    </div>

</div>
